<template>  
  <v-card class="ch-room-component">
    <v-card-title class="room-title">
      <i class="fas fa-tag fa-fw"></i>
      <v-checkbox
        v-if="showCheckbox"
        :label="`${ room.name }`"
        color="error darken-4"
        v-model="getCheckValue"
        hide-details
        light
      ></v-checkbox>
      <p
        v-else
        class="invalid-room-title mb-0"
      >
        <v-icon class="mr-1">not_interested</v-icon>
        {{ room.name }}
      </p>
    </v-card-title>
    <v-card-text class="room-body">
      <ul>
        <li class="room-info">
          <i class="fas fa-check fa-fw"></i>
          {{ room.status }}
        </li>
        <li class="room-info">
          <i class="fas fa-bed fa-fw"></i>
          {{ room.roomtypeName }}
        </li>
        <li class="room-info">
          <i class="fas fa-building fa-fw"></i>
          {{ buildingName }}
        </li>
      </ul>
    </v-card-text>
  </v-card>
</template>

<script>
  import { bookingsEventBus } from '@/components/admin/bookings/bookingsEventBus';
  import api from '../../api';

  export default {
    props: [
      'room', 'bookingoomtype', 'selectedRoomIds',
    ],
    data() {
      return {
        buildingName: null,
        checked: null,
        showCheckbox: null,
      };
    },
    methods: {
      getBuilding() {
        const id = {
          hotel_id: this.room.hotel_id,
          building_id: this.room.building_id,
        };
        api.getBuilding(id)
        .then((result) => {
          if (result.status === 200) {
            this.buildingName = result.data.name;
          }
        })
        .catch((err) => {
          console.err(err.response.data.message);
        });
      },
      /**
       * @description checkbox disable
       * @returns boolean
       */
      isDisabled() {
        if (this.room.status === 'installed') {
          this.showCheckbox = true;
        } else {
          this.showCheckbox = false;
        }
      },
      /**
       * @description 현재 룸이 방배정이 되어있는지 확인
       */
      isChecked() {
        if (this.selectedRoomIds.includes(this.room.id)) {
          this.checked = true;
        } else {
          this.checked = false;
        }
      },
    },
    computed: {
      getCheckValue: {
        get() {
          return this.checked;
        },
        set(newValue) {
          this.checked = newValue;
          if (!this.checked) {
            bookingsEventBus.$emit('uncheckedRoom', this.room.id);
          } else {
            bookingsEventBus.$emit('checkedRoom', this.room.id);
          }
        },
      },
    },
    mounted() {
      // console.log(`this.room: ${JSON.stringify(this.room, null, '\t')}`);
      this.getBuilding();
      this.isChecked();
      this.isDisabled();

      // NOTE: roomType이 바뀌면 방배정그리드 또한 배정가능한것과 가능하지 않은것으로 바뀌어야 한다, re-rendering
      bookingsEventBus.$on('changeRoomType', (obj) => {
        window.console.log(`change: ${obj}`);
      });
    },
  };
</script>

<style scoped>
.room-info {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components/customized-components/Room.vue